module.exports = __webpack_public_path__ + "img/produkt-brambory.c5dbe3fb.jpg";